module.exports = __webpack_public_path__ + "static/media/006.1df45391.jpg";